import React, { ButtonHTMLAttributes } from "react";
import { StyledButton } from "./styles";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "delete" | "discord";
  icon?: React.ReactElement;
  withBorder?: boolean;
  active?: boolean;
}

export const Button: React.FC<ButtonProps> = ({
  variant = "primary",
  icon,
  withBorder = false,
  active = false,
  children,
  ...props
}) => {
  return (
    <StyledButton
      $variant={variant}
      $icon={icon}
      $withBorder={withBorder}
      $active={active}
      {...props}
    >
      {icon && icon}
      {children}
    </StyledButton>
  );
};

export default Button;
